// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

// Define a service using a base URL and expected endpoints
export const apNotesAPI = createApi({
  reducerPath: 'apNotesAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ['notes'],
  endpoints: (builder) => ({
    getAPNotesList: builder.query<any, { apCode: string; year: string }>({
      query: ({ apCode, year }) => ({
        url: `/am/ap/${apCode}/notes/year/${year}`,
        method: 'GET',
      }),
      providesTags: ['notes'],
    }),

    createAPNote: builder.mutation<any, { apCode: string; payload: any }>({
      query: ({ apCode, payload }) => ({
        url: `/am/ap/${apCode}/note/create`,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['notes'],
    }),
    editAPNote: builder.mutation<any, { apCode: string; payload: any }>({
      query: ({ apCode, payload }) => ({
        url: `/am/ap/${apCode}/note/update`,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['notes'],
    }),

    deleteAPNote: builder.mutation<any, { id: string | number | null }>({
      query: ({ id }) => ({
        url: `/am/ap/note/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['notes'],
    }),
    searchAPNote: builder.query<any, { apCode: string; query: string }>({
      query: ({ apCode, query }) => ({
        url: `/am/ap/${apCode}/note/search`,
        method: 'GET',
        params: { query },
      }),
      providesTags: ['notes'],
    }),
    getUsersListByNativeIDs: builder.query<any, getUsersByNativeIDArgTypes>({
      query: ({ nativeIDs }) => ({
        url: `/auth/users/native`,
        method: 'GET',
        params: { native: nativeIDs },
      }),
      providesTags: ['notes'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAPNotesListQuery,
  useCreateAPNoteMutation,
  useEditAPNoteMutation,
  useDeleteAPNoteMutation,
  useSearchAPNoteQuery,
  useGetUsersListByNativeIDsQuery,
} = apNotesAPI;
